
import {
  Box,
  Chip,
  Paper,
  Typography,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState } from "react";

type ConfigItem = {
  id: number;
  name: string;
  count: number;
  performance: string;
  brands: number;
  disabled?: boolean;
  current?: boolean;
  alreadyConnected?: boolean;
};

const configs: ConfigItem[] = [
  {
    id: 1,
    name: "ia_user_per_day_default_no_purchases",
    count: 13,
    performance: "daily_user_performance",
    brands: 87,
    disabled: true,
    current: true,
  },
  {
    id: 2,
    name: "ia_user_per_day_account_detailed",
    count: 12,
    performance: "daily_user_performance",
    brands: 5,
  },
  {
    id: 3,
    name: "ia_user_per_day_default_no_net_revenue",
    count: 22,
    performance: "daily_user_performance",
    brands: 7,
  },
  {
    id: 4,
    name: "ia_user_per_day_default_no_rs",
    count: 19,
    performance: "daily_user_performance",
    brands: 13,
  },
  {
    id: 5,
    name: "ia_user_per_day_default_no_net_revenue2",
    count: 29,
    performance: "daily_user_performance",
    brands: 34,
    disabled: true,
    alreadyConnected: true,
  },
  {
    id: 6,
    name: "ia_user_per_day_account_detailed_no_Rs",
    count: 262,
    performance: "daily_user_performance",
    brands: 43,
    disabled: true,
    alreadyConnected: true,
  },
];

export default function ManualConfigurationModalBodyOne() {
  const [selectedId, setSelectedId] = useState<number | null>(2);

  const handleSelect = (item: ConfigItem) => {
    if (item.disabled) return;

    setSelectedId(item.id);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "400px",
        overflow: "auto",
      }}
    >
      {configs.map((item) => {
        const isSelected = selectedId === item.id;
        const isDisabled = !!item.disabled;

        return (
          <Paper
            key={item.id}
            elevation={0}
            onClick={() => handleSelect(item)}
            sx={{
              px: 1,
              py: 1,
              mb: 0.5,
              borderRadius: 2,
              cursor: isDisabled ? "not-allowed" : "pointer",
              border: isSelected
                ? "1px solid #9C27B080"
                : "1px solid transparent",
              bgcolor: isSelected
                ? "#9C27B014"
                : "transparent",
              opacity: isDisabled ? 0.45 : 1,
              transition: "all 0.2s ease",
              "&:hover": {
                bgcolor: isDisabled
                  ? "transparent"
                  : isSelected
                  ? "#9C27B014"
                  : "#fafafa",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.7,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: "text.primary",
                    }}
                  >
                    {item.name}
                  </Typography>

                  <Typography
                    component="span"
                    sx={{
                      fontSize: 12,
                      color: "#00000099",
                    }}
                  >
                    ({item.count})
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.7,
                    color: "text.secondary",
                  }}
                >
                  <ArrowForwardIcon
                    sx={{
                      fontSize: 12,
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#00000099",
                    }}
                  >
                    {item.performance} · {item.brands} brands
                  </Typography>
                </Box>
              </Box>

              {item.current && (
                <Chip
                  label="Current"
                  variant="outlined"
                  size="small"
                  sx={{
                    color: "#E65100",
                    borderColor: "#E65100",
                    bgcolor: "#fffaf5",
                    fontWeight: 500,
                    fontSize: 10,
                  }}
                />
              )}

              {item.alreadyConnected && (
                <Chip
                  label="Already Connected"
                  variant="outlined"
                  size="small"
                  sx={{
                    color: "#E65100",
                    borderColor: "#E65100",
                    bgcolor: "#fffaf5",
                    fontWeight: 500,
                    fontSize: 10,
                  }}
                />
              )}
            </Box>
          </Paper>
        );
      })}
    </Box>
  );
}